"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiGameLoader = void 0;
exports["default"] = HowlerMiddleware;
var _howler = require("howler");
var WebFont = _interopRequireWildcard(require("webfontloader"));
var _rxjs = require("rxjs");
var _pixi = require("pixi.js");
var _core = require("@dragon/core");
var _loader = require("@pixi-spine/loader-3.8");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Old, pixi loader based loader service.
 */
var PixiGameLoader = exports.PixiGameLoader = /*#__PURE__*/function () {
  function PixiGameLoader() {
    var _this = this;
    _classCallCheck(this, PixiGameLoader);
    /**Initial game critical files */
    _defineProperty(this, "loader", void 0);
    /** Files that can load after game started, such as sounds */
    _defineProperty(this, "bgLoader", void 0);
    /**for files before regular loads */
    _defineProperty(this, "preLoader", void 0);
    _defineProperty(this, "webFontNames", []);
    _defineProperty(this, "webFontUrls", []);
    _defineProperty(this, "onProgressCb", void 0);
    _defineProperty(this, "resources", void 0);
    _defineProperty(this, "preloadedResources", void 0);
    _defineProperty(this, "assetUrl", void 0);
    _defineProperty(this, "currentLanguage", void 0);
    _defineProperty(this, "_gameTranslations", void 0);
    _defineProperty(this, "_sharedTranslations", void 0);
    _defineProperty(this, "_translations", void 0);
    _defineProperty(this, "onError", function (cb) {
      _this.loader.onError.add(function (exception, loader, resource) {
        reportError("Failed to load file: " + resource.url + " " + exception);
        cb(exception, loader, resource);
      });
    });
    _defineProperty(this, "onProgress", function (cb) {
      _this.onProgressCb = cb;
      _this.loader.onProgress.add(function (a, b) {
        cb(a, b);
      });
    });
    _defineProperty(this, "onProgressPreloader", function (cb) {
      _this.onProgressCb = cb;
      _this.preLoader.onProgress.add(function (a, b) {
        cb(a, b);
      });
    });
    /** add font to the webfontloader config. */
    _defineProperty(this, "loadFont", function (url, name) {
      //console.log("ADDING TO WEBFONT LOADER: " + name+"  "+ url)
      _this.webFontNames.push(name);
      _this.webFontUrls.push(url);
    });
    _defineProperty(this, "startLoadingFonts", function () {
      return new Promise(function (resolve, reject) {
        var webFontConfig = {
          custom: {
            families: _this.webFontNames,
            urls: _this.webFontUrls
          },
          //loading: () => {
          // console.log("loading ");
          //},
          active: function active() {
            //  console.log(" active ");
            resolve(true);
          },
          inactive: function inactive() {
            console.error("font loading error");
            reportError("Failed to load font, inactive.");
            // wee keep on going even if font failed.
            resolve(true);
          },
          // fontactive: function () {
          //     console.log("fontactive ");
          // }
          timeout: 400000 // we have to have a long time out here for slow loading
        };
        WebFont.load(webFontConfig);
      });
    });
    // Spine loader plugin
    this.loader = new _pixi.Loader();
    this.loader.use(_loader.SpineParser.use);
    this.preLoader = new _pixi.Loader();
    this.preLoader.use(_loader.SpineParser.use);
    this.bgLoader = new _pixi.Loader();
    this.bgLoader.use(_loader.SpineParser.use);

    //We expose the resources on the loader wrapper. this is needed to get animation resources. HACK!!!
    // TODO find better solution.
    this.resources = this.loader.resources;
    this.preloadedResources = this.preLoader.resources;

    // in case we do "critical sound files"
    // this.loader.pre(HowlerMiddleware)
    this.bgLoader.pre(HowlerMiddleware);
    this.onLoad(function (a, b) {
      var config = _core.CORE.getState().config;
      _this.currentLanguage = config.language ? config.language : config.locale;

      // Supports shared language file but will override any keys with the game specific language file.
      // Depends on the shared to be loaded first. if not it will override game specific with shared
      if (b.name === "language_" + _this.currentLanguage) _this._gameTranslations = b.data;
      if (b.name === "language_shared_" + _this.currentLanguage) _this._sharedTranslations = b.data;

      // Note that we have to do JSON.parse here, the pixi loader does not do it for us since the tUrl does not have .json file extension.
      // loader does not use content-type to determine if it should parse as json.
      if (b.name === "language_translator_" + _this.currentLanguage) {
        _core.CORE.registerTranslation(_this.currentLanguage, JSON.parse(b.data));
      }

      // this dictates order. important game is last.
      if (_this._gameTranslations && _this._sharedTranslations) {
        _core.CORE.registerTranslation(_this.currentLanguage, Object.assign({}, _this._sharedTranslations, _this._gameTranslations));
        // cleanup
        _this._sharedTranslations = undefined;
        _this._gameTranslations = undefined;
      }
    });
  }
  return _createClass(PixiGameLoader, [{
    key: "add",
    value: function add(file, name, metadata) {
      if (this.assetUrl) file = this.assetUrl + file;
      if (name.endsWith("_font")) {
        this.loadFont(file, name.split("_")[0]);
      } else if (!name) this.loader.add(file);else {
        if (metadata) this.loader.add(name, file, {
          metadata: metadata
        });else this.loader.add(name, file);
      }
    }
  }, {
    key: "preloadStart",
    value: function preloadStart(callback) {
      this.preLoader.onComplete.add(callback);
      this.preLoader.load();
    }
  }, {
    key: "preloadAdd",
    value: function preloadAdd(file, name, metadata, callback) {
      if (this.assetUrl) file = this.assetUrl + file;
      if (metadata) {
        this.preLoader.add(name, file, {
          metadata: metadata
        });
      } else {
        this.preLoader.add(name, file);
      }
      if (callback) this.preLoader.onComplete.add(callback);
    }

    /** Start loading, will call CB when fonts and Main loader completes. and will start backgroundLoader but not wait for it. */
  }, {
    key: "load",
    value: function load(cb) {
      var _this2 = this;
      // turn the pixi resourseloader into an observable
      var loaderObs = new _rxjs.Observable(function (observer) {
        _this2.loader.load(function () {
          return observer.next();
        });
      });
      /// wait for both font loader and pixi resource loader to emit before we complete.
      (0, _rxjs.zip)((0, _rxjs.from)(this.startLoadingFonts()), loaderObs).subscribe(function () {
        cb();
        // start BG loader, fire and forget
        _this2.bgLoader.load(function () {
          _core.CORE.dispatch({
            type: _core.BG_LOADING_COMPLETE
          });
        });
      });
    }
  }, {
    key: "getFile",
    value: function getFile(file) {
      return this.loader.resources[file];
    }
  }, {
    key: "onLoad",
    value: function onLoad(cb) {
      this.loader.onLoad.add(cb);
    }
  }, {
    key: "loadSoundSprite",
    value: function loadSoundSprite(soundPack, jsonUrl, volume, cb) {
      if (this.assetUrl) jsonUrl = this.assetUrl + jsonUrl;
      this.bgLoader.onLoad.add(function (loader, resource) {
        if (resource.url == jsonUrl) {
          // Data got url and the sprite info. We dispatch createSoundSprite based on that.
          var to = jsonUrl.lastIndexOf("/");
          to = to == -1 ? jsonUrl.length : to + 1;
          to = jsonUrl.substring(0, to);
          for (var index = 0; index < resource.data.urls.length; index++) {
            resource.data.urls[index] = to + resource.data.urls[index];
          }
          _core.CORE.dispatch((0, _core.createSoundSprite)(soundPack, resource.data.sprite, resource.data.urls, volume, false, false));
        }
      });
      this.bgLoader.add("soundSprite" + soundPack, jsonUrl, cb);
    }
  }]);
}();
function HowlerMiddleware(resource, next) {
  if (resource && ["wav", "ogg", "mp3", "mpeg", "webm"].includes(resource.extension)) {
    //   resource._setFlag(loaders.Resource.STATUS_FLAGS.LOADING, true);
    var options = JSON.parse(JSON.stringify(resource.metadata));
    options.src = [resource.url];
    options.onload = function () {
      resource.complete();
      next();
    };
    options.onloaderror = function (id, message) {
      console.error(resource);
      resource.abort(message);
      next();
    };
    resource.data = new _howler.Howl(options);
  } else {
    next();
  }
}
//# sourceMappingURL=PixiGameLoader.js.map